import React from "react";

import * as S from "./CabInfoBar.styles";

const CabInfoBarUI = ({ margin, text }) => {
	if (!text) return null;
  return (
    <S.InfoBar margin={margin}>
      <p dangerouslySetInnerHTML = {{ __html: text }}></p>
    </S.InfoBar>
  );
};

export default CabInfoBarUI;
